import * as React from 'react'
import { FC, useCallback, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  bulkUpdateExpectedClosingDate,
  bulkUpdateNextActionDate,
} from '@user/store/opportunity'
import { BulkUpdateExpectedClosingDateInput } from '@user/components/xGrid/atoms/BulkActions/typings/BulkUpdateExpectedClosingDate/BulkUpdateExpectedClosingDateInput'
import { BulkUpdateExpectedClosingDateForm } from '@user/components/xGrid/atoms/BulkActions/BulkUpdateExpectedClosingDate'

export const BulkUpdateExpectedClosingDateOpps: FC = () => {
  const dispatch = useAppDispatch()

  const validateRows = useCallback(
    async (model: BulkUpdateExpectedClosingDateInput) => {
      const response = await dispatch(bulkUpdateExpectedClosingDate({ model }))
      if (bulkUpdateExpectedClosingDate.fulfilled.match(response)) {
        return response.payload.model
      }
    },
    [dispatch],
  )

  const [updateExpected, setUpdateExpected] = useState<boolean>(false)

  const onSubmit = useCallback(
    async (model: BulkUpdateExpectedClosingDateInput) => {
      await dispatch(
        bulkUpdateExpectedClosingDate({
          model,
          mode: 'commit',
        }),
      )
      if (updateExpected)
        await dispatch(
          bulkUpdateNextActionDate({
            ids: model.ids,
            nextActionDate: model.expectedClosingDate,
          }),
        )
    },
    [dispatch, updateExpected],
  )

  return (
    <BulkUpdateExpectedClosingDateForm
      validateRows={validateRows}
      onSubmit={onSubmit}
      setUpdateExpected={setUpdateExpected}
    />
  )
}
BulkUpdateExpectedClosingDateOpps.displayName = 'BulkExpectedClosingDateOpps'
